module.exports = __webpack_public_path__ + "static/media/Shade6.e725ce47.jpg";